import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";

interface MultipleprintHeaderProps {
  title: string;
  registrationNumber: string;
  sampleNumber?: string;
  mainImageName?: string | null;
  t: (key: string) => string;
  itemType?: "MULTIPLE" | "EXEMPLAIRE";
}

export function MultipleprintHeader({
  title,
  registrationNumber,
  sampleNumber,
  // `mainImageName` n'est plus affiché ici : le nom de l'illustration principale
  // est désormais en légende sous l'image (voir MultipleprintImages).
  mainImageName: _mainImageName,
  t,
  itemType: _itemType,
}: MultipleprintHeaderProps) {
  return (
    <div className="flex items-center justify-between subpixel-antialiased">
      <div className="flex flex-col gap-1 w-full">
        <div className="flex flex-col gap-1 mb-1 w-full">
          {registrationNumber && (
            <HoverCard>
              <HoverCardTrigger className="font-semibold text-base w-fit text-black cursor-pointer">
                {registrationNumber}
              </HoverCardTrigger>
              <HoverCardContent
                className="font-semibold text-xs p-2 border-none shadow"
                side="top"
              >
                {t("singleArtworkHoverCardNumber")}
              </HoverCardContent>
            </HoverCard>
          )}
          <p className="font-semibold text-[28px] leading-tight w-full">{title}</p>
        </div>
        {sampleNumber && (
          <p className="font-normal text-sm">{`${t("singleMultipleprintExemplaireNumero")} ${sampleNumber}`}</p>
        )}
      </div>
    </div>
  );
}
